import $ from 'jquery'
import {
  prepareChessboard,
  showMagnus,
  loadNextConfiguration,
  validateMove,
  restrictMove,
  hideCapturedPieces
} from '../../utils';
import ChessBoard from '../../components/chessBoard';
import {
  BLACK_INITIAL_MOVE,
  WHITE_PIECE_SEARCH_KEY,
} from '../../utils/constants';

var moveCount;

/**
* @name lesson4Assignment3
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson4Assignment3(config) {
  let coordinateClass = config.coordinateClass,
    next = config.next,
    initialBoardPosition = config.position;

  let afterLoad = function () {
    prepareChessboard(config);
    moveCount = 0;
  }

  let onDragStart = function (source, piece, position, orientation) {
    return restrictMove(piece, WHITE_PIECE_SEARCH_KEY)
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateMove(source, target, piece, true);
  }

  var onSnapEnd = function (source, target, piece) {
    let boardFen = ChessBoard.board.fen();

    moveCount++;

    if (moveCount === 9) {
      if ($('#chessBoard .chessboard-63f37').find(coordinateClass).length === 0) {
        loadNextConfiguration(2000, next, true)
      } else {
        moveCount = 0;

        showMagnus({
          data: 'Oops...!!!<br/> Try again',
          position: 'left',
          styleClass: 'xs'
        })

        $('.square-55d63').addClass('no-action');

        setTimeout(function () {
          showMagnus({
            data: "The pawns are frozen, only the Knight moves.",
            position: 'left',
            styleClass: 'lg'
          });

          $('.square-55d63').removeClass('no-action');
          hideCapturedPieces();
          ChessBoard.board.position(initialBoardPosition);
          ChessBoard.game = new window.Chess(initialBoardPosition + BLACK_INITIAL_MOVE);
          return 'snapback';
        }, 4000)
      }
    }

    ChessBoard.game = new window.Chess(boardFen + BLACK_INITIAL_MOVE);
  };

  const chessConfig = {
    config: {
      position: initialBoardPosition,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_4/assignments.js